"use client";

import { useSyncExternalStore } from "react";

// Light is the default; the choice is kept in localStorage ("theme": "light" | "dark") and applied before the
// first paint by the script in the root layout.
function subscribe(cb: () => void) {
  const o = new MutationObserver(cb);
  o.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
  return () => o.disconnect();
}
const isLight = () => document.documentElement.classList.contains("light");

export default function ThemeSwitch() {
  const light = useSyncExternalStore(subscribe, isLight, () => true);
  return (
    <button
      type="button"
      aria-label={light ? "Dunkles Design" : "Helles Design"}
      aria-pressed={light}
      onClick={() => {
        const next = !light;
        document.documentElement.classList.toggle("light", next);
        try {
          localStorage.setItem("theme", next ? "light" : "dark");
        } catch {}
      }}
      className="flex size-11 cursor-pointer items-center justify-center rounded-full border-[1.5px] border-line-strong text-ink-2 hover:text-accent"
    >
      {light ? (
        // moon: switch to dark
        <svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20 14.5A8.5 8.5 0 0 1 9.5 4 8.5 8.5 0 1 0 20 14.5z" />
        </svg>
      ) : (
        // sun: switch to light
        <svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
          <circle cx="12" cy="12" r="4" />
          <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
        </svg>
      )}
    </button>
  );
}
